module.exports = __webpack_public_path__ + "img/AiCheckin_Horizontal.1dd31907.png";